/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components.data').factory('DashboardResourceFactory', function (
    $resource,
    EndPointService
) {
    return $resource(EndPointService.dashboardEndpoint, {'showCompleted': '@showCompleted', 'includeSubSeries': '@includeSubSeries'},
        {
            getRestoreSteps: {
                method: 'GET',
                url: EndPointService.dashboardEndpoint + '/restoreSteps',
                isArray: false
            },
            getFileCopySteps: {
                method: 'GET',
                url: EndPointService.dashboardEndpoint + '/fileCopySteps',
                isArray: false
            },
            getTranscodeSteps: {
                method: 'GET',
                url: EndPointService.dashboardEndpoint + '/transcodeSteps',
                isArray: false
            },
            getDeliverySteps: {
                method: 'GET',
                url: EndPointService.dashboardEndpoint + '/deliverySteps',
                isArray: false
            },
            getDeliveryBandwidth: {
                method: 'GET',
                url: EndPointService.dashboardEndpoint + '/deliveryBandwidth',
                isArray: false
            },
            getDeliveryMetrics: {
                method: 'GET',
                url: EndPointService.dashboardEndpoint + '/deliveryMetrics',
                isArray: false
            },
            getDeliveryBandwidthReport: {
                method: 'GET',
                url: EndPointService.reportEndpoint + '/delivery/bandwidth',
                isArray: false
            }
        });
});
